import React from 'react';

// allowNegative: conserva un «-» al principio (las rectificativas por
// diferencias llevan en negativo lo que baja). Sin él, el signo se quita.
export const normalizeDecimalInput = (value, { allowNegative = false } = {}) => {
  const texto = String(value ?? '')
    .trim()
    .replace(/\s+/g, '');
  const negativo = allowNegative && texto.startsWith('-');
  const rawValue = texto.replace(/[^0-9,.]/g, '');

  if (rawValue === '') {
    return negativo ? '-' : '';
  }

  const lastDotIndex = rawValue.lastIndexOf('.');
  const lastCommaIndex = rawValue.lastIndexOf(',');
  const decimalSeparatorIndex = Math.max(lastDotIndex, lastCommaIndex);
  const signo = negativo ? '-' : '';

  if (decimalSeparatorIndex === -1) {
    return `${signo}${rawValue.replace(/[.,]/g, '')}`;
  }

  const integerPart = rawValue.slice(0, decimalSeparatorIndex).replace(/[.,]/g, '') || '0';
  const decimalPart = rawValue.slice(decimalSeparatorIndex + 1).replace(/[.,]/g, '');
  return decimalPart === ''
    ? `${signo}${integerPart}.`
    : `${signo}${integerPart}.${decimalPart}`;
};

const DecimalInput = ({
  value,
  onValueChange,
  className = 'form-input',
  onFocus,
  selectOnFocus = true,
  allowNegative = false,
  ...props
}) => {
  const handleFocus = (event) => {
    onFocus?.(event);
    if (selectOnFocus) {
      event.target.select();
    }
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      className={className}
      value={value ?? ''}
      onChange={(event) => onValueChange(normalizeDecimalInput(event.target.value, { allowNegative }), event)}
      onFocus={handleFocus}
      {...props}
    />
  );
};

export default DecimalInput;
